import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

class NscDeliveryRangesClient {
  static baseUrl = BASE_URL;

  static getDeliveryRanges(user, selectedMarket) {
    let url = this.baseUrl + "/nsc/deliveryRanges";
    if (selectedMarket.length > 0) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }
    /*eslint-disable no-console*/

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDeliveryRangesNew(user, selectedMarket) {
    let url = this.baseUrl + "/new/nsc/deliveryRanges";
    if (selectedMarket.length > 0) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async saveDeliveryRanges(data, user, selectedMarket) {
    let url = this.baseUrl + "/nsc/deliveryRanges";
    if (selectedMarket.length > 0) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }
    return await axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async saveDeliveryRangesNew(data, user, selectedMarket) {
    let url = this.baseUrl + "/new/nsc/deliveryRanges";

    if (selectedMarket.length > 0) {
      url = url + `?selectedMarket=${selectedMarket}`;
    }
    return await axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default NscDeliveryRangesClient;
